export const PACKAGE_NAME = '@project44/shared-components';
